// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import PinsNotRegisteredDealerCriteria from './pins-not-registered-dealer-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

const PinsNotRegisteredReportCriteria = props =>
    <div className='pins-not-registered-criteria'>
        <div className='criteria-container'>
            <div className='primary-criteria'>
                <PinsNotRegisteredDealerCriteria
                    onDealerSelect={props.onDealerSelect}
                    onSelectAllDealers={props.onSelectAllDealers}
                    selectedAccounts={props.selectedAccounts}
                    selectedDealers={props.selectedDealers}
                />
            </div>
            <div className='secondary-criteria'>
                <LabeledCriteria
                    className='pin-criteria'
                    isRequired={false}
                    label='PIN'
                    maxLength='17'
                    onInputChange={props.onPinInputChange}
                    placeholder='PIN'
                    type='text'
                    value={props.pin}
                />
                <LabeledCriteria
                    className='model-criteria'
                    isRequired={false}
                    label='MODEL'
                    maxLength='19'
                    onInputChange={props.onModelInputChange}
                    placeholder='MODEL'
                    type='text'
                    value={props.model}
                />
            </div>
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateReport}
            showExport={true}
            showReport={true}
        />
    </div>;

PinsNotRegisteredReportCriteria.displayName = 'PinsNotRegisteredReportCriteria';
PinsNotRegisteredReportCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    model: PropTypes.string.isRequired,
    onCreateReport: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onModelInputChange: PropTypes.func.isRequired,
    onPinInputChange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default PinsNotRegisteredReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/components/pins-not-registered-report-criteria.js